<template>
  <v-menu :close-on-content-click="false" attach >
    <template v-slot:activator="{ on: { click } }">
      <v-tooltip bottom nudge-bottom="-5" attach >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn icon small @click="click">
              <i class="fa-solid fa-list-check" style="font-size: 16px"></i>
            </v-btn>
          </div>
        </template>
        <span>Change Columns Visibility</span>
      </v-tooltip>
    </template>
    <v-list class="pb-0" >
      <div class="d-flex my-1 justify-space-between align-center">
        <h5 class="pl-4">Columns Visibility</h5>
        <v-menu offset-y attach left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon class="mx-2" v-bind="attrs" v-on="on">
              <v-icon small>fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="reset()">
              <v-list-item-title>Reset</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item @click="model.active = true">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </div>

      <div class="items-list">
        <draggable @end="reOrderList" :list="internalColumns" tag="div" item-key="value">
          <div
            v-for="column in internalColumns"
            :key="'columnList' + column.value"
            class="d-flex align-center px-2 py-1"
            :class="{'light-grey': isColumnSelected(column)}">
            <v-btn class="handle mr-1" icon><v-icon small>fa-bars</v-icon></v-btn>
            <v-checkbox
              :disabled="!column.hidable"
              :input-value="isColumnSelected(column)"
              @click.stop="toggleSelection(column)"
              color="primary"
              class="mt-0 pt-0"
              hide-details
              dense></v-checkbox>
            <div class="ml-2" style="font-size: 12px !important">
              {{ column.text }}
            </div>
          </div>
        </draggable>
      </div>
    </v-list>
    <!-- <v-dialog :value="model.active" width="400" persistent>
      <v-card>
        <div class="d-flex justify-space-between align-center pr-2">
          <v-card-title class="font-weight-bold">
            <v-icon left size="18">fal fa-pen</v-icon>
            Edit Columns Name
          </v-card-title>
          <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-5" style="max-height: 500px; overflow: auto">
          <v-form v-model="model.valid">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Old Name</th>
                    <th class="text-left">New Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in value" :key="item.value">
                    <td>{{ item.text }}</td>
                    <td>
                      <v-text-field-alt
                        v-model="selected[item.value]"
                        hide-details></v-text-field-alt>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="saveChanges"
            :disabled="!model.valid || !model.hasChanges">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-menu>
</template>

<script>
 import {$getFromLocal,$setToLocal} from '@Utils';
 import draggable from 'vuedraggable';
 import { log, warn, error } from '@/utils/debugLogger';
  export default {
    name: 'columns-visibility-control',
    props: {
      value: {
        type: Array,
        required: true,
      },
      defaults: {
        type: Array,
        required: true,
      },
      withColumnsOrder: {
        type: Boolean,
        default: true,
      },
      storageKey: {
        type: String,
        default: '',
      },
      schemaUpdatedAt: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        internalColumns: [],
        selectedValues: [],
        selected: {},
        selectedCemented: {},
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
        isInitialized: false,
      };
    },
    mounted() {
      this.initialize();
    },
    activated() {
      if (!this.isInitialized) {
        this.initialize();
      }
    },
    

    methods: {
      initialize() {
        if (!Array.isArray(this.value)) {
          warn('ColumnsVisibilityControl', 'value prop is not an array or is undefined. Initializing with empty. Value was:', JSON.stringify(this.value));
          this.internalColumns = [];
          this.initializeSelection(this.internalColumns);
          return;
        }

        // Async tables mount before their server schema arrives. Hydrating saved preferences at
        // that point would emit preference-only objects (value/text/order) back to the parent and
        // make the non-empty array block the later schema initialization. Wait for the fresh
        // definitions so dataType and the other server-driven column metadata cannot be lost.
        if (this.value.length === 0 && (!this.defaults || this.defaults.length === 0)) {
          this.internalColumns = [];
          this.initializeSelection(this.internalColumns);
          this.isInitialized = true;
          return;
        }

        const storedColumnsData = this.storageKey ? $getFromLocal(`${this.storageKey}-filteredCols`, true, null) : null;
        const storedSchemaUpdatedAt = this.storageKey ? $getFromLocal(`${this.storageKey}-schemaUpdatedAt`, false, null) : null;

        // Check if schema has been updated since last save
        const schemaChanged = this.schemaUpdatedAt && storedSchemaUpdatedAt !== this.schemaUpdatedAt;

        let workingColumns;

        if (schemaChanged && this.defaults && this.defaults.length > 0) {
          // Schema was updated - merge fresh schema with stored preferences

          if (storedColumnsData && Array.isArray(storedColumnsData)) {
            // Create map of stored preferences by value (internal column ID)
            const storedMap = new Map(storedColumnsData.map(c => [c.value, c]));

            // Merge: use fresh schema but preserve user preferences
            workingColumns = this.defaults.map((freshCol, index) => {
              const storedCol = storedMap.get(freshCol.value);

              if (storedCol) {
                // Column exists in both - preserve user preferences, update display name
                return {
                  ...freshCol,                    // Fresh data from schema (text, dataType, etc.)
                  hidden: storedCol.hidden,       // Preserve user's visibility preference
                  order: this.withColumnsOrder
                    ? (storedCol.order !== undefined ? storedCol.order : index)
                    : undefined,                  // Preserve user's order preference
                };
              } else {
                // New column - use defaults (visible, at end)
                return {
                  ...freshCol,
                  order: this.withColumnsOrder ? (storedColumnsData.length + index) : undefined,
                };
              }
            });
          } else {
            // No stored data - use fresh defaults as-is
            workingColumns = structuredClone(this.defaults);
          }

          // Clear old localStorage (will be saved with new data after)
          if (this.storageKey) {
            localStorage.removeItem('R-' + `${this.storageKey}-filteredCols`);
            localStorage.removeItem('R-' + `${this.storageKey}-schemaUpdatedAt`);
          }
        } else if (storedColumnsData && Array.isArray(storedColumnsData)) {
          // Schema unchanged - safe to use stored preferences
          // Start with value prop, then merge stored preferences
          workingColumns = structuredClone(this.value);
          const storedMap = new Map(storedColumnsData.map(c => [c.value, c]));
          const storedValues = new Set(storedColumnsData.map(c => c.value));
          const propValues = new Set(workingColumns.map(c => c.value));
          const hasNewColumns = Array.from(propValues).some(value => !storedValues.has(value));

          if (hasNewColumns) {
            workingColumns = workingColumns.map(propCol => {
              const storedCol = storedMap.get(propCol.value);
              const baseOrder = propCol.order;
              const baseHidden = propCol.hidden;
              let finalHidden = baseHidden;
              if (storedCol && storedCol.hidden !== undefined) {
                finalHidden = storedCol.hidden;
              }
              let finalOrder = baseOrder;
              if (this.withColumnsOrder && storedCol && storedCol.order !== undefined) {
                finalOrder = storedCol.order;
              }
              return {
                ...propCol,
                hidden: finalHidden,
                order: this.withColumnsOrder ? finalOrder : undefined,
              };
            });
          } else {
            // Merge stored preferences with fresh column definitions
            // Use defaults as the source of truth for display properties (width, dataType, etc.)
            const defaultsMap = new Map((this.defaults || []).map(c => [c.value, c]));
            workingColumns = storedColumnsData.map(storedCol => {
              const propCol = workingColumns.find(p => p.value === storedCol.value);
              const defaultCol = defaultsMap.get(storedCol.value);
              // Defaults carry the current server/code metadata. The v-model can still contain a
              // preference-only object emitted before an async schema arrived, so it is only the
              // fallback here; hidden/order are restored explicitly below.
              const freshCol = defaultCol || propCol;
              if (freshCol) {
                return {
                  ...freshCol,
                  hidden: storedCol.hidden,
                  order: this.withColumnsOrder ? storedCol.order : undefined,
                };
              }
              return storedCol;
            });
          }
        } else {
          // No stored data, use value prop as-is
          workingColumns = structuredClone(this.value);
        }

        if (this.withColumnsOrder) {
          workingColumns = workingColumns.map((col, index) => ({
            ...col,
            order: col.order !== undefined ? col.order : index,
          }));
          workingColumns = this.sortByOrder(workingColumns);
        } else {
          workingColumns = workingColumns.map(col => {
            const { order, ...rest } = col; // eslint-disable-line no-unused-vars
            return rest;
          });
        }

        this.internalColumns = workingColumns;
        this.initializeSelection(this.internalColumns);
        this.isInitialized = true;

        if (JSON.stringify(this.internalColumns) !== JSON.stringify(this.value)) {
          this.$emit('input', structuredClone(this.internalColumns));
        }
        
        if (this.storageKey && !storedColumnsData) {
          this.saveColumns();
        }
      },
      initializeSelection(columnsToSelectFrom) {
        // Set selected values from visible columns
        this.selectedValues = columnsToSelectFrom
          .filter(item => !item.hidden)
          .map(item => item.value);
      },
      
      isColumnSelected(column) {
        return this.selectedValues.includes(column.value);
      },
      
      toggleSelection(column) {
        if (!column.hidable) return;
        
        const index = this.selectedValues.indexOf(column.value);
        if (index === -1) {
          // Add to selection
          this.selectedValues.push(column.value);
        } else {
          // Remove from selection
          this.selectedValues.splice(index, 1);
        }
        
        this.updateInternalColumnsAndEmit();
      },
      
      updateInternalColumnsAndEmit() {
        let newInternalHeaders = this.internalColumns.map(column => ({
          ...column,
          hidden: !this.selectedValues.includes(column.value),
        }));

        this.internalColumns = newInternalHeaders;
        this.$emit('input', structuredClone(this.internalColumns));
        this.saveColumns();
      },
      
      reOrderList() {
        // internalColumns is already updated by vuedraggable
        this.internalColumns.forEach((elm, index) => {
          elm.order = index;
        });
        this.$emit('input', structuredClone(this.internalColumns));
        this.saveColumns();
      },
      
      sortByOrder(headers) {
        return [...headers].sort((a, b) => (a.order || 0) - (b.order || 0));
      },
      
      reset() {
        if (!Array.isArray(this.defaults) || this.defaults.length === 0) {
          warn('ColumnsVisibilityControl', 'Cannot reset - defaults prop is not a valid array');
          return;
        }
        
        let resetCols = structuredClone(this.defaults);
        if (this.withColumnsOrder) {
          resetCols = resetCols.map((col, index) => ({
            ...col,
            order: col.order !== undefined ? col.order : index,
          }));
          resetCols = this.sortByOrder(resetCols);
        } else {
          resetCols = resetCols.map(col => {
            const { order, ...rest } = col; // eslint-disable-line no-unused-vars
            return rest;
          });
        }

        this.internalColumns = resetCols;
        this.initializeSelection(this.internalColumns);
        this.$emit('input', structuredClone(this.internalColumns));
        this.saveColumns();
      },
      
      saveChanges() {
        let headers = this.internalColumns.map((elm) => {
          const newElm = { ...elm };
          newElm.hidden = !this.selectedValues.includes(elm.value);
          if (this.selected[elm.value]) {
            newElm.text = this.selected[elm.value];
          }
          return newElm;
        });
        
        this.internalColumns = headers;
        this.$emit('input', structuredClone(this.internalColumns));
        this.saveColumns();
        this.cementSelected();
        this.closeDialog();
      },
      
      closeDialog() {
        this.model.active = false;
        this.selected = structuredClone(this.selectedCemented);
      },
      
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
        this.checkForChanges();
      },
      
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.model.hasChanges = false;
      },
      
      checkForChanges() {
        if (!this.model.active) return;
        this.model.hasChanges = JSON.stringify(this.selected) !== JSON.stringify(this.selectedCemented);
      },

      saveColumns() {
        if (this.storageKey) {
          // Only persist user preferences (hidden, order, value, text) — not display properties
          // like width, which are code-driven and should always come from defaults/props
          const columnsToStore = this.internalColumns.map(({ value, text, hidden, order, hidable }) => ({
            value,
            text,
            hidden,
            hidable,
            ...(order !== undefined && { order }),
          }));
          $setToLocal(`${this.storageKey}-filteredCols`, columnsToStore, true);
          // Save schema timestamp alongside preferences for cache invalidation
          if (this.schemaUpdatedAt) {
            $setToLocal(`${this.storageKey}-schemaUpdatedAt`, this.schemaUpdatedAt, false);
          }
        }
      }
    },
    computed: {
      input: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    watch: {
      defaults: {
        handler(newValue, oldValue) {
          // Async grids start with only their fixed columns, then append the server schema.
          // Rehydrate at that boundary so saved visibility/order is merged onto the newly
          // available metadata instead of leaving preference-only column objects in the parent.
          if (this.isInitialized
            && Array.isArray(newValue)
            && newValue.length > (Array.isArray(oldValue) ? oldValue.length : 0)) {
            this.initialize();
          }
        },
        deep: true,
      },
      value: {
        handler(newValue) {
          if (this.isInitialized && JSON.stringify(newValue) !== JSON.stringify(this.internalColumns)) {
            this.initialize();
          }
        },
        deep: true,
      },
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
      schemaUpdatedAt: {
        handler(newVal, oldVal) {
          // When schemaUpdatedAt changes from null to a value (API data arrived), re-check localStorage
          if (newVal && !oldVal && this.isInitialized) {
            const storedSchemaUpdatedAt = this.storageKey
              ? $getFromLocal(`${this.storageKey}-schemaUpdatedAt`, false, null)
              : null;

            if (storedSchemaUpdatedAt !== newVal && this.defaults && this.defaults.length > 0) {
              // Get stored preferences for smart merge
              const storedColumnsData = this.storageKey
                ? $getFromLocal(`${this.storageKey}-filteredCols`, true, null)
                : null;

              let freshColumns;

              if (storedColumnsData && Array.isArray(storedColumnsData)) {
                // Smart merge: preserve user preferences, update schema data
                const storedMap = new Map(storedColumnsData.map(c => [c.value, c]));

                freshColumns = this.defaults.map((freshCol, index) => {
                  const storedCol = storedMap.get(freshCol.value);
                  if (storedCol) {
                    // Column exists in both - preserve preferences, update display name
                    return {
                      ...freshCol,
                      hidden: storedCol.hidden,
                      order: this.withColumnsOrder
                        ? (storedCol.order !== undefined ? storedCol.order : index)
                        : undefined,
                    };
                  }
                  // New column - visible at end
                  return {
                    ...freshCol,
                    order: this.withColumnsOrder ? (storedColumnsData.length + index) : undefined,
                  };
                });
              } else {
                // No stored data - use fresh defaults
                freshColumns = structuredClone(this.defaults);
              }

              // Apply ordering
              if (this.withColumnsOrder) {
                freshColumns = freshColumns.map((col, index) => ({
                  ...col,
                  order: col.order !== undefined ? col.order : index,
                }));
                freshColumns = this.sortByOrder(freshColumns);
              } else {
                freshColumns = freshColumns.map(col => {
                  const { order, ...rest } = col; // eslint-disable-line no-unused-vars
                  return rest;
                });
              }

              // Clear old and save new
              if (this.storageKey) {
                localStorage.removeItem('R-' + `${this.storageKey}-filteredCols`);
                localStorage.removeItem('R-' + `${this.storageKey}-schemaUpdatedAt`);
              }

              this.internalColumns = freshColumns;
              this.initializeSelection(this.internalColumns);
              this.$emit('input', structuredClone(this.internalColumns));
              this.saveColumns();
            }
          }
        },
        immediate: false,
      },
    },
    components: {
      draggable
    },
  };
</script>
<style scoped lang="scss">
.items-list > div {
  max-height: 400px;
  overflow-y: auto;
}
</style>
